import React, {FC, useState} from "react"

import {CompanyNewsTile} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import {H4} from "@irati/ui/src/Typography"

import {Modal} from "../../Modal"
import ContentForm from "./Form"
import {SelectedTab} from "./types"

interface Props {
  companyNewsTile: CompanyNewsTile
  onClose: () => void
}

const EditTileModal: FC<Props> = ({companyNewsTile, onClose}) => {
  const [isPreview, setPreview] = useState(false)
  return (
    <Modal
      header={
        <H4>
          <FormattedMessage id="platform.homepage.companyNews.editContent.title" />
        </H4>
      }
      onClose={onClose}>
      <ContentForm
        companyNewsTile={companyNewsTile}
        currentTab={SelectedTab.EDIT}
        onClose={onClose}
        isPreview={isPreview}
        setPreview={setPreview}
      />
    </Modal>
  )
}

export default EditTileModal
